export const OPERATION_GROUP_TYPE = {
    'IMPORT_OPERATION': 'IMPORT_OPERATION',
    'QUERIES_OPERATION': 'QUERIES_OPERATION',
    'BACKUP_AND_RESTORE_OPERATION': 'BACKUP_AND_RESTORE_OPERATION',
    'CLUSTER_OPERATION': 'CLUSTER_OPERATION'
};
